import { useReducer, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../../services/api/BaseUrl';
import { userReducer } from '../../../reducers/user/UserReducer';
import {
  FETCHED_USER,
  LOADING_STARTS,
  LOADING_STOPS,
} from '../../../constants/types/user/UserTypes';

const useMac = (mac) => {
  const [{ user, loading }, dispatch] = useReducer(userReducer, {
    user: null,
    loading: false,
  });

  useEffect(() => {
    const getDetailWithMac = async () => {
      dispatch({
        type: LOADING_STARTS,
      });

      try {
        const response = await axios.get(`${API_URL}/users/mac/${mac}`);
        console.log(response.data);
        if (response.data) {
          dispatch({
            type: FETCHED_USER,
            payload: response.data,
          });
        }
      } catch (error) {
        dispatch({
          type: LOADING_STOPS,
        });
      }
    };

    getDetailWithMac();
  }, [mac]);

  return {
    loading,
    user,
  };
};
export default useMac;
